module.exports = __webpack_public_path__ + "static/img/1.5e94b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/1.png
// module id = InzO
// module chunks = 0